import baseUrl from "../../../../../utilities/baseUrl";
import axios from "axios";

const useChaparRate = async chaparData => {
  try {
    const chaparBody = {
      addressId: chaparData.SAddress.id,
      getterAddressId: chaparData.RAddress.id,
      methodRequest: chaparData.chaparType.compony_type_post.chaparId,
      data: chaparData.rowsData,
      totalSpecialService: chaparData.totalSpecialService,
      needCollecting: chaparData.needCollecting,
      needSMS: chaparData.needSMS,
      needPrint: chaparData.needPrint,
      isCod: chaparData.isCod,
      isBulk: false,
      internalSectionId: 1,
      collectingType: 1,
    };

    const token = localStorage.getItem("token");

    const chaparUrl = baseUrl + "/internalpost/v1/chaparRate";
    const result = await axios.post(chaparUrl, chaparBody, {
      headers: {
        Authorization: "Bearer " + token,
      },
      timeout: 18000,
    });

    if (result && result.status === 200) {
      return {
        chaparData: result.data,
        Data: chaparData.chaparType,
      };
    }
  } catch (error) {
    return { Data: chaparData.chaparType, chaparData: { quote: 0 } };
  }
};

export default useChaparRate;
